import React, { useState, useEffect } from 'react'
import { Button, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import SurveyDetails from './components/survey-details/SurveyDetails'
import SurveyQuestions from './components/survey-questions/SurveyQuestions'
import { useSelector, useDispatch } from 'react-redux'
import { IMainState } from 'store/states'
import { IBlockInstanceModel } from 'models/block.model'
import * as fromActions from 'store/actions/blocks.action'
import styles from './Index.module.scss'

interface ISurvey {
  onCancel: () => void
  editing: boolean
}

const detailDataDefaultValues = {
  name: '',
  description: '',
  mandatory: true,
}

const errors = {
  title: '',
  description: '',
  mandatory: '',
  questionTitle: '',
  questionType: '',
}

const Survey: React.FC<ISurvey> = ({ onCancel, editing }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { edit } = useSelector(({ blocks }: IMainState) => blocks)
  const [currentStep, setCurrentStep] = useState(1)
  const [detailData, setDetailData] = useState(
    detailDataDefaultValues as IBlockInstanceModel
  )

  useEffect(() => {
    setDetailData({ ...detailDataDefaultValues, ...edit })
  }, [edit])

  const handleNextStep = () => {
    if (edit.id) {
      dispatch({
        type: fromActions.EDIT_SURVEY_BLOCK_DETAILS,
        payload: detailData,
      })
      setCurrentStep(2)
    } else {
      onCancel()
    }
  }

  return (
    <>
      <Col xs={3} className={'d-flex flex-column border-right pl-0 '}>
        <h1 className={styles.title}>
          {editing
            ? t('administration.blocks.type.survey.edit')
            : t('administration.blocks.type.survey.new')}
        </h1>
        <div className={styles.stepButtons}>
          <Button
            variant="outline-primary"
            className={'mt-3 text-left w-100'}
            active={currentStep === 1}
            disabled={currentStep === 1}
            onClick={() => setCurrentStep(1)}
          >
            1. {t('administration.blocks.type.survey.details')}
          </Button>
          <Button
            variant="outline-primary"
            className={'mt-2 text-left w-100'}
            active={currentStep === 2}
            disabled={currentStep === 2}
            onClick={handleNextStep}
          >
            2. {t('administration.blocks.type.survey.question.plural')}
          </Button>
        </div>
      </Col>

      <Col xs={9} className={'pr-0 pt-3 '}>
        {currentStep === 1 ? (
          <SurveyDetails
            values={detailData}
            onChange={setDetailData}
            errors={errors}
            onNext={() => handleNextStep()}
            onCancel={onCancel}
          />
        ) : (
          <SurveyQuestions
            onCancel={onCancel}
            blockId={edit.id}
            instanceId={edit.instanceId}
          />
        )}
      </Col>
    </>
  )
}

export default Survey
